import { string } from 'prop-types';
import { scroller } from 'react-scroll';
import { withHandlers } from 'recompose';
import OrangeButton from '../../core/components/OrangeButton';

const configureHandlers = withHandlers({
  onClick: props => () =>
    scroller.scrollTo(props.to, {
      duration: 500,
      smooth: true,
      spy: true,
      offset: -70,
    }),
});

const SmoothOrageButton = configureHandlers(OrangeButton);

export default SmoothOrageButton;

SmoothOrageButton.propTypes = {
  to: string.isRequired,
};
